import { combineReducers } from "redux";
import AuthReducer from "./AuthReducer";
import EventReducer from "./EventReducer";
import UserReducer from "./UserReducer";
import {DashboardReducer} from './DashboardReducer'
import {CatalogReducer} from './CatalogReducer'
const RootReducer = combineReducers({
  AuthReducer,
  EventReducer,
  UserReducer,
  DashboardReducer,
  CatalogReducer
});

export default RootReducer;
